import { track } from "jiffy-analytics";
import madeStore from "components/jiffy/vue-product-details-print/store/store";
import { MODES } from "components/jiffy/vue-product-details-print/misc/constants";
import ScrollToElement from "common/utils/ui/scroll-to-element";
import {
  showDesignUploadModal,
  resetInitSections
} from "components/jiffy/design-upload-cta/design-upload-cta";
import "./pdp-made-banner.scss";

const $getBanner = () => document.querySelector(".js-pdp-made-banner");
const getProductId = () => document.getElementById("product-page-container").dataset.realProductId;

const goToDesignLab = () => {
  showDesignUploadModal();

  track("upload_step_viewed", {
    product_id: getProductId(),
    trigger_location: "PDP Upsell"
  });
};

const scrollToMadeApp = () => {
  madeStore.commit("app/setMode", MODES.MADE);

  setTimeout(() => {
    ScrollToElement.scrollIntoViewBySelector(".js-pdp-experience-switcher");
  }, 0);
};

const init = () => {
  const $banner = $getBanner();
  const cb = $banner?.dataset.showDesignUploadModal === "true" ? goToDesignLab : scrollToMadeApp;
  $banner?.addEventListener("click", cb);
  resetInitSections();
};

export default init;
